import axios from 'axios';

const SettingService = {
    getSettings: () => {
        return axios.get("api/settings", {}, { withCredentials: true });
    },
    updateSetting: (request) => {
        if (typeof request.settingValue != "string" && request.settingValue !== null)
            request.settingValue = request.settingValue.toString();
        return axios.put("api/settings", request, { withCredentials: true });
    }
};

export default SettingService;